import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#hero" className="inline-block font-heading text-2xl font-bold text-foreground-900 mb-4">
              {t('site.name')}
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              {t('footer.quick_links')}
            </h4>
            <ul className="space-y-2.5">
              {[
                { key: 'nav.home', href: '#hero' },
                { key: 'nav.about', href: '#nosotros' },
                { key: 'nav.presentations', href: '#presentaciones' },
                { key: 'nav.catalog', href: '#catalogo' },
                { key: 'nav.contact', href: '#contacto' },
              ].map((link) => (
                <li key={link.key}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                  >
                    {t(link.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              Redes Sociales
            </h4>
            <div className="flex flex-col space-y-2.5">
              <a
                href="https://www.instagram.com/kremsi_cr?igsh=OXJ0M3pkNTF4YnJz"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <i className="ri-instagram-line"></i> Instagram
              </a>
              <a
                href="https://www.tiktok.com/@kremsi_cr?_r=1&_t=ZS-98O4KMXJYij"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <i className="ri-tiktok-line"></i> TikTok
              </a>
              <a
                href="https://wa.me/50670555703"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <i className="ri-whatsapp-line"></i> WhatsApp
              </a>
              <a
                href="mailto:kremsi@annayasrl.com"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <i className="ri-mail-line"></i> kremsi@annayasrl.com
              </a>
            </div>
          </div>

          {/* Newsletter placeholder - just elegant empty space */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              Sabor artesanal
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Elaborado con dedicación en cada lote. De Costa Rica para tu mesa.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-200">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {year} {t('site.name')}. {t('footer.rights')}
          </p>
          <p className="text-xs text-foreground-400">
            Guadalupe, San José
          </p>
        </div>
      </div>
    </footer>
  );
}